if (!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    selectors = {
      swiper: '.swiper',
      scrollbar: '.js-slider-dots',
      navigation: {
        prevEl: '.swiper-button-left',
        nextEl: '.swiper-button-right',
      },
    };
    settings = {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      navigation: {
        prevEl: this.selectors.navigation.prevEl,
        nextEl: this.selectors.navigation.nextEl,
      },
      autoplay: this.hasAttribute('slider-autoplay')
        ? {
            delay: this.getAttribute('slider-autoplay'),
          }
        : false,
    };
    slider = undefined;
    id = undefined;
    dotContainers = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const swiper = this.querySelector(this.selectors.swiper);
      if (!swiper) return;

      this.slider = new Swiper(swiper, this.settings);
      this.dotContainers = this.querySelectorAll(this.selectors.pagination);
      for (const dotContainer of this.dotContainers) {
        dotContainer.addEventListener('click', (event) =>
          this.onDotClick(event),
        );
      }
    }

    /**
     * Handle dot click.
     *
     * @param {Event} event
     */
    onDotClick(event) {
      const index = event.target.getAttribute('data-dot-index');
      if (!index) return;
      this.slider.slideTo(index);
    }
  }
  customElements.define('hero-slider', HeroSlider);
}
